/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum PrintProofReviewResultEnum {
    approved = "approved",
    rejected = "rejected"
}

export type PrintProofReviewResult = PrintProofReviewResultEnum;